import {
  Card,
  Field,
  FieldLabel,
  LeaderGroupCombobox,
  StickyFilters,
  useHideBasedOnLeaderGroup,
  UserCombobox,
} from '@/components'
import { cn } from '@/lib/utils'
import type { UseLeaderGroupsSuspenseReturn } from '@/utils'
import { type UpdateFormFn, useTranslate } from '@ur-solutions/react-hooks'

export interface RemainingDrivingTimeFilterForm {
  users: string[]
  leaderGroup: string | null
  orderBy: string
}

interface Props {
  filter: RemainingDrivingTimeFilterForm
  updateForm: UpdateFormFn<RemainingDrivingTimeFilterForm>
  leaderGroups: UseLeaderGroupsSuspenseReturn
}

export const RemainingDrivingTimeFilters: React.FC<Props> = ({
  filter,
  updateForm,
  leaderGroups,
}) => {
  const translations = useTranslate({
    users: 'common.users',
    leaderGroup: 'common.leader-group',
    select: 'common.select-ellipsis',
  })

  const hideUserItem = useHideBasedOnLeaderGroup(
    filter.leaderGroup ?? '',
    leaderGroups
  )

  return (
    <StickyFilters>
      <Card className="mb-4 p-0" contentClassName="p-0">
        <form className={cn('grid gap-4 p-4', 'md:flex md:flex-wrap')}>
          <Field>
            <FieldLabel>{translations.users}</FieldLabel>
            <UserCombobox
              value={filter.users}
              className="max-w-[350px]"
              mode="multiple"
              hideItem={hideUserItem}
              placeholder={translations.select}
              onChange={users => updateForm({ users })}
            />
          </Field>

          {leaderGroups.hasAccess && (
            <Field>
              <FieldLabel>{translations.leaderGroup}</FieldLabel>
              <LeaderGroupCombobox
                value={filter.leaderGroup ?? ''}
                mode="single"
                module="Activities"
                clearable
                placeholder={translations.select}
                onChange={value =>
                  updateForm({ leaderGroup: value || null, users: [] })
                }
              />
            </Field>
          )}
        </form>
      </Card>
    </StickyFilters>
  )
}
